import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { AccordionItem, AccordionItemTitle, AccordionItemBody } from 'react-accessible-accordion';
import { mp } from '../../constants/utils';

import Title from '../shared/Title';
import Icon from '../shared/Icon';
import Text from '../shared/Text';
import { borderRadius } from 'styled-system';

export const fadein = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const StyledFAQTitleContainer = styled.div`
  font-weight: 700;
`;

const StyledFAQBodyContainer = styled.div``;

export const StyledAccordionItem = (
  hideBottom,
  open,
  borderBottom,
  borderColor = '#e6e6e6',
  hideTop = false,
) => {
  const bTop = !hideTop ? `.1rem solid ${borderColor}` : '';
  const pBottom = hideBottom ? '0.4rem' : '1.2rem';
  const bBottom = borderBottom && !open ? `.1rem solid ${borderColor}` : '';
  return {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '1.2rem',
    paddingBottom: `${pBottom}`,
    borderTop: `${bTop}`,
    borderBottom: `${bBottom}`,
    outline: 'none',
    transition: 'padding .55s cubic-bezier(.63,.64,.3,1)',
  };
};

export const StyledItemIcon = (open) => {
  const degrees = open ? '0' : '45';
  return {
    minWidth: '40px',
    transform: `rotate(${degrees}deg)`,
    transition: 'all .1s cubic-bezier(.63,.64,.3,1)',
  };
};

export const StyledAccordionBody = (open, borderBottom, borderColor = '#e6e6e6') => {
  const bBottom = open && borderBottom ? `.1rem solid ${borderColor}` : '';
  return {
    animationName: fadein,
    paddingBottom: '1.2rem',
    animationDuration: '0.35s',
    animationTimingFunction: 'ease-in-out',
    borderBottom: `${bBottom}`,
  };
};

class FAQuestion extends Component {
  state = {
    open: false,
    hideBottom: false,
    borderBottom: false,
  };

  componentDidMount() {
    const { expanded, borderBottom } = this.props;
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      open: expanded,
      hideBottom: expanded,
      borderBottom,
    });
  }

  render() {
    const {
      question,
      expanded,
      event,
      questionLevel,
      textType,
      borderColor,
      textColor,
    } = this.props;
    const { open, rotation, hideBottom, borderBottom } = this.state;
    return (
      <AccordionItem expanded={expanded}>
        <StyledFAQTitleContainer
          onClick={() => {
            if (event) {
              mp(event);
            }
            this.setState({ rotation: rotation + 45, open: !open, hideBottom: !hideBottom });
          }}
        >
          <AccordionItemTitle
            style={StyledAccordionItem(
              hideBottom,
              open,
              borderBottom,
              borderColor,
              question.hideTop,
            )}
          >
            <Title
              level={questionLevel}
              medium
              styles={css`
                margin: 0px;
              `}
              color={textColor}
            >
              {question.question}
            </Title>
            <Icon
              icon="cross2"
              color={textColor ? textColor : 'rgba(2, 39, 89, 0.4)'}
              size={20}
              style={StyledItemIcon(open)}
            />
          </AccordionItemTitle>
        </StyledFAQTitleContainer>
        <StyledFAQBodyContainer style={{ paddingTop: '0px' }}>
          <AccordionItemBody style={StyledAccordionBody(open, borderBottom, borderColor)}>
            <Text type={textType} style={{ marginTop: '10px' }} color={textColor}>
              {question.answer}
            </Text>
          </AccordionItemBody>
        </StyledFAQBodyContainer>
      </AccordionItem>
    );
  }
}

FAQuestion.propTypes = {
  question: PropTypes.object,
  expanded: PropTypes.bool,
  borderBottom: PropTypes.bool,
  event: PropTypes.string,
  questionLevel: PropTypes.number,
  textType: PropTypes.string,
};

FAQuestion.defaultPropTypes = {
  question: {},
  expanded: false,
  borderBottom: false,
  event: null,
  questionLevel: 6,
  textType: 'body1',
};

export default FAQuestion;
